import React from "react";
import Skeleton from "@mui/material/Skeleton";

export function ProcessingTaskRowSkeleton({ index }) {
    return (
        <tr key={index}>
            <td>
                <Skeleton variant="text" width="65%" height={24} />
                <Skeleton variant="text" width="45%" height={18} />
            </td>
            <td>
                <Skeleton variant="text" width="70%" height={24} />
            </td>
            <td>
                <Skeleton variant="text" width={90} height={24} />
            </td>
            <td>
                <Skeleton variant="text" width={150} height={24} />
            </td>
            <td>
                <Skeleton variant="rectangular" width={80} height={26} className="oct_skeleton-radius-12" />
            </td>
        </tr>
    );
}

export default ProcessingTaskRowSkeleton;
